import { lazy } from "react";

import PersonalCustomerSuccessPastNotes from "pages/Personal/PastNotes/CustomerSuccess/View";
import PersonalInsideSalesPastNotes from "pages/Personal/PastNotes/InsideSales/View";

import { RouteType } from "types/index";
import { ENTITY_TYPE } from "constants/index";
import { personalSlugParam, routePaths } from "routes/constants";

const GeneralSetting = lazy(() => import("pages/Personal/GeneralSetting"));
const ClientList = lazy(() => import("pages/Personal/Client/List"));
const EmployeeList = lazy(() => import("pages/Personal/Employee/List"));
const StaffList = lazy(() => import("pages/Personal/Staff/List"));

const StafBasicGeneralInformation = lazy(
  () => import("pages/Personal/Staff/GeneralSetting/Basic/View")
);

const StaffDesiredJobPreferences = lazy(
  () => import("pages/Personal/Staff/GeneralSetting/DesiredJobPreferences/View")
);

const StafCurrentStatusGeneralInformation = lazy(
  () => import("pages/Personal/Staff/GeneralSetting/CurrentStatus/View")
);

const StafOtherSettingGeneralInformation = lazy(
  () => import("pages/Personal/Staff/GeneralSetting/OtherSetting/View")
);

const StafPastStatusGeneralInformation = lazy(
  () => import("pages/Personal/Staff/GeneralSetting/PastStatus/View")
);

const StaffWorkHistoryAndOtherGeneralInformation = lazy(
  () => import("pages/Personal/Staff/GeneralSetting/WorkHistoryAndOther/View")
);

const StaffLaborManagementGeneralInformation = lazy(
  () => import("pages/Personal/Staff/GeneralSetting/LaborManagement/View")
);

const EmployeeOtherSettingGeneralInformation = lazy(
  () => import("pages/Personal/Employee/GeneralSetting/OtherSetting/View")
);

const EmployeeLaborManagement = lazy(
  () => import("pages/Personal/Employee/GeneralSetting/LaborManagement/View")
);

const EmployeeBasicGeneralInformation = lazy(
  () => import("pages/Personal/Employee/GeneralSetting/Basic/View")
);

const ClientBasicGeneralInformation = lazy(
  () => import("pages/Personal/Client/GeneralSetting/Basic/View")
);

const ClientOtherSettingGeneralInformation = lazy(
  () => import("pages/Personal/Client/GeneralSetting/OtherSetting/View")
);

const ClientEmployedStaff = lazy(
  () => import("pages/Personal/Client/EmployedStaff/View")
);

const PersonalEmployeeBUMember = lazy(
  () => import("pages/Personal/Employee/Member/BusinessUnit")
);

const PersonalEmployeeCorporationMember = lazy(
  () => import("pages/Personal/Employee/Member/Corporation")
);

const PersonalStaffBUMember = lazy(
  () => import("pages/Personal/Staff/Member/BusinessUnit")
);

const PersonalClientBUMember = lazy(
  () => import("pages/Personal/Client/Member/BusinessUnit")
);

const PersonalBUMember = lazy(
  () => import("pages/Personal/Member/BusinessUnit")
);

const PersonalCorporationMember = lazy(
  () => import("pages/Personal/Member/Corporation")
);
const MyRole = lazy(() => import("pages/Personal/MyRole/View"));

const CorporationGeneralSettingView = lazy(
  () => import("modules/Corporation/GeneralSettingView/View")
);

export const personalRoutes: RouteType[] = [
  {
    path: routePaths.root.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.generalSetting.root,
    label: "general_settings",
  },
  {
    path: routePaths.root.generalSetting.root,
    element: <GeneralSetting />,
    requiredAuth: true,
    label: "general_settings",
  },
  {
    path: routePaths.root.generalSetting.laborManagement.root,
    element: <EmployeeLaborManagement isOwnData />,
    requiredAuth: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.generalSetting.otherSetting.root,
    element: <EmployeeOtherSettingGeneralInformation isOwnData />,
    requiredAuth: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.member.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.member.bu.root,
    label: "members",
  },
  {
    path: routePaths.root.member.bu.root,
    element: <PersonalBUMember />,
    requiredAuth: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.member.corp.root,
    element: <PersonalCorporationMember />,
    requiredAuth: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.myRole.root,
    element: <MyRole />,
    requiredAuth: true,
    label: "my_roles",
  },

  // staff
  {
    path: routePaths.root.staff.root.root,
    element: <StaffList />,
    requiredAuth: true,
    label: "staffs",
    superAdminOnly: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.staff.root.pStaffSlug.generalSetting.root,
    requireAssignment: true,
    label: personalSlugParam,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.generalSetting.root,
    element: <StafBasicGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    label: "general_settings",
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.generalSetting
      .desiredJobPreferences.root,
    element: <StaffDesiredJobPreferences />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.generalSetting.currentStatus
      .root,
    element: <StafCurrentStatusGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.generalSetting.otherSetting
      .root,
    element: <StafOtherSettingGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.generalSetting.pastStatus.root,
    element: <StafPastStatusGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.generalSetting
      .workHistoryAndOther.root,
    element: <StaffWorkHistoryAndOtherGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.generalSetting.laborManagement
      .root,
    element: <StaffLaborManagementGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.member.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.staff.root.pStaffSlug.member.bu.root,
    label: "members",
    requireAssignment: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.member.bu.root,
    element: <PersonalStaffBUMember />,
    requiredAuth: true,
    hideBreadcrumb: true,
    requireAssignment: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.employedCorporation.root,
    element: <CorporationGeneralSettingView entityType={ENTITY_TYPE.STAFF} />,
    requiredAuth: true,
    label: "employed_corporation",
    requireAssignment: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.pastNotes.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.staff.root.pStaffSlug.pastNotes.insideSales.root,
    requireAssignment: true,
    label: personalSlugParam,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.pastNotes.insideSales.root,
    element: <PersonalInsideSalesPastNotes />,
    requiredAuth: true,
    label: "past_notes",
    requireAssignment: true,
  },
  {
    path: routePaths.root.staff.root.pStaffSlug.pastNotes.customerSuccess.root,
    element: <PersonalCustomerSuccessPastNotes />,
    requiredAuth: true,
    label: "past_notes",
    requireAssignment: true,
  },
  // end of staff

  // employee
  {
    path: routePaths.root.employee.root.root,
    element: <EmployeeList />,
    requiredAuth: true,
    label: "hs_employee",
    superAdminOnly: true,
  },
  {
    path: routePaths.root.employee.root.pEmployeeSlug.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.employee.root.pEmployeeSlug.generalSetting.root,
    requireAssignment: true,
    label: personalSlugParam,
  },
  {
    path: routePaths.root.employee.root.pEmployeeSlug.generalSetting.root,
    element: <EmployeeBasicGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    label: "general_settings",
  },
  {
    path: routePaths.root.employee.root.pEmployeeSlug.generalSetting
      .otherSetting.root,
    element: <EmployeeOtherSettingGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.employee.root.pEmployeeSlug.generalSetting
      .laborManagement.root,
    element: <EmployeeLaborManagement />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.employee.root.pEmployeeSlug.member.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.employee.root.pEmployeeSlug.member.bu.root,
    label: "members",
    requireAssignment: true,
  },
  {
    path: routePaths.root.employee.root.pEmployeeSlug.member.bu.root,
    element: <PersonalEmployeeBUMember />,
    requiredAuth: true,
    hideBreadcrumb: true,
    requireAssignment: true,
  },
  {
    path: routePaths.root.employee.root.pEmployeeSlug.member.corp.root,
    element: <PersonalEmployeeCorporationMember />,
    requiredAuth: true,
    hideBreadcrumb: true,
    requireAssignment: true,
  },
  // end of employee

  // client
  {
    path: routePaths.root.client.root.root,
    element: <ClientList />,
    requiredAuth: true,
    label: "clients",
    superAdminOnly: true,
  },
  {
    path: routePaths.root.client.root.pClientSlug.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.client.root.pClientSlug.generalSetting.root,
    requireAssignment: true,
    label: personalSlugParam,
  },
  {
    path: routePaths.root.client.root.pClientSlug.generalSetting.root,
    element: <ClientBasicGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    label: "general_settings",
  },
  {
    path: routePaths.root.client.root.pClientSlug.generalSetting.otherSetting
      .root,
    element: <ClientOtherSettingGeneralInformation />,
    requiredAuth: true,
    requireAssignment: true,
    hideBreadcrumb: true,
  },
  {
    path: routePaths.root.client.root.pClientSlug.member.root,
    element: null,
    requiredAuth: true,
    redirect: routePaths.root.client.root.pClientSlug.member.bu.root,
    hideBreadcrumb: true,
    requireAssignment: true,
  },
  {
    path: routePaths.root.client.root.pClientSlug.member.bu.root,
    element: <PersonalClientBUMember />,
    requiredAuth: true,
    label: "members",
    requireAssignment: true,
  },
  {
    path: routePaths.root.client.root.pClientSlug.corporationDetail.root,
    element: <CorporationGeneralSettingView entityType={ENTITY_TYPE.CLIENT} />,
    requiredAuth: true,
    label: "corporation_details",
    requireAssignment: true,
  },
  {
    path: routePaths.root.client.root.pClientSlug.employedStaff.root,
    element: <ClientEmployedStaff />,
    requiredAuth: true,
    label: "employed_staff",
    requireAssignment: true,
  },
  // end of client
];
